import { getCookie, setCookie } from '../cookie-helper';
import { renderCartContent } from './render';


// Define the name of the cookie to store the cart it
const cookieName = "f5-cart";


/**
 * Function to handle adding a product to the cart.
 * @param {Int} productId Product ID to add to the cart
 */
export function addToCart(productId) {
    const cart = getCart(); // Get the cart from the cookie
    // Check if cart already contains product id; 
    if (cart.includes(productId)) {
        // If so, don't add it aother time
        return;
    } else {
        // If not so, add the product to the cart
        cart.push(productId);
        updateCart(cart);
    }

}


/**
 * Function to handle removing a product from the cart.
 * @param {Int} productId Product ID to remove from the cart
 */
export function removeFromCart(productId) {
    var cart = getCart();
    var index = cart.indexOf(productId);
    if (index > -1) {
        cart.splice(index, 1);
    }
    updateCart(cart);
}


/**
 * Function to get the cart from the cookie.
 * @returns Array of cart products
 */
export function getCart() {
    let cart = [];
    const cartCookie = getCookie(cookieName);
    if (cartCookie !== null) {
        cart = JSON.parse(cartCookie);
    }
    return cart;
}


/**
 * Function to update the cart in the cookie and re-render the via in the front-end.
 * @param {Array} cart Array of product IDs to set in the cookie
 */
function updateCart(cart) {
    renderCartContent(cart); // Render cart content
    const cartJson = JSON.stringify(cart); // Stringify cart array for cookie
    setCookie(cookieName, cartJson, .08); // Set cookie to expire in around 2 hours
}